<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Chemin du fichier</mat-label>
                    <input matInput [value]="data.record.filePath" readonly autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Date</mat-label>
                    <input matInput [value]="data.record.date" readonly autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Adresse de l'emetteur du mail</mat-label>
                    <input matInput [value]="data.record.mailFromAddress" readonly autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Adresses des destinataires du mail</mat-label>
                    <input matInput [value]="data.record.mailToAddresses" readonly autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Sujet du mail</mat-label>
                    <input matInput [value]="data.record.mailSubject" readonly autocomplete="off" />
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Corps du mail</mat-label>
                    <textarea matInput type="text" autocomplete="off" rows="10" [value]="data.record.mailBody" readonly></textarea>
                </mat-form-field>
            </div>
            <div class="form-item">
                <mat-form-field>
                    <mat-label>Nombre de pièces-jointes du mail</mat-label>
                    <input matInput [value]="data.record.mailAttachmentsCount" readonly autocomplete="off" />
                </mat-form-field>
            </div>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-raised-button class="accent-button" (click)="cancel()">Ok</button>
    </mat-card-actions>
</mat-card>
